import { render, staticRenderFns } from "./ScreenSetting.vue?vue&type=template&id=06807634&scoped=true&"
import script from "./ScreenSetting.vue?vue&type=script&lang=js&"
export * from "./ScreenSetting.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSetting.vue?vue&type=style&index=0&id=06807634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06807634",
  null
  
)

component.options.__file = "ScreenSetting.vue"
export default component.exports